import React, { Component } from 'react';

import './Events.css';

import { Link } from 'react-router-dom';

/**
 * Modules
 */
import { List, Input, Button, Modal, message, Breadcrumb } from 'antd';
import { getEvents, deleteAEvent } from '../../utils/eventsFunctions';

/**
 * Components
 */
import EventForm from '../shared/eventForm/EventForm';

import { getAuth } from 'firebase/auth';
import TopBar from '../topBar/TopBar';

class Events extends Component {

    constructor(props) {
        super(props)
        this.state = {
            arrayOfChamps: [],
            filteredArrayOfChamps: [],

            loadingListOfChamps: true,

            champInfoDialog: false,
            champInfoObject: '',
            champInfoPoints: [],

            champDeleteDialog: false,
            champDeleteObject: '',

            champEditDialog: false,
        }
    }

    componentDidMount = () => {
        /* Get all champs */
        this.updateListOfChamps();

        getAuth();
    }

    /**
     * Methods to update list of champs
     */
    updateListOfChamps = async () => {
        this.setState({ loadingListOfChamps: true })

        let localArray = await getEvents();

        this.setState({
            arrayOfChamps: localArray,
            filteredArrayOfChamps: localArray,
            loadingListOfChamps: false,
        });
    }

    /**
     * Methods to read champ
     */
    searchChamp = (value) => {
        let localFilteredArray = []
        for (let key in this.state.arrayOfChamps) {
            if (this.state.arrayOfChamps[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                localFilteredArray.push(this.state.arrayOfChamps[key])
        }
        this.setState({
            filteredArrayOfChamps: localFilteredArray
        })
    }

    openChampInfoDialog = (champObject) => {
        let localData = new Date(champObject.data)
        champObject.dataToShow = localData.getDate() + '/' + (localData.getMonth() + 1) + '/' + localData.getFullYear()

        this.setState({
            champInfoDialog: true,
            champInfoObject: champObject,
            champEditObjectData: localData
        })
    }

    closeChampInfoDialog = () => {
        this.setState({
            champInfoDialog: false,
            champInfoObject: '',
            arrayOfSelectStudents: []
        })
    }

    /**
     * Methods to create champ
     */
    openChampAddDialog = () => {
        this.setState({
            champAddDialog: true
        })
    }

    getReturnFromModalChampForm = () => {
        this.updateListOfChamps()
        this.closeChampAddDialog()
        message.success('Evento cadastrado com sucesso')
    }

    closeChampAddDialog = () => {
        this.setState({
            champAddDialog: false,
        })
    }

    /**
     * Methods to delete champ
     */
    openChampDeleteDialog = (obj) => {
        this.setState({ champDeleteObject: obj.__key })
        let _this = this

        Modal.confirm({
            title: 'Tem certeza que quer deletar esse evento?',
            content: 'Essa operação não poderá ser desfeita',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Não',
            onOk() {
                _this.deleteChamp()
            }
        })
    }

    deleteChamp = async () => {
        this.setState({ loadingListOfChamps: true })

        const eventDeleted = await deleteAEvent(this.state.champDeleteObject);
        if (!eventDeleted) message.error('Erro ao deletar o evento');
        this.updateListOfChamps();
    }

    /**
     * Methods to edit champ
     */
    openChampEditDialog = (champ) => {
        this.setState({
            champEditDialog: true,
            champToEdit: champ,
        })
    }

    getReturnFromModalChampEditForm = () => {
        this.updateListOfChamps()
        this.closeChampEditDialog()
        message.success('Evento atualizado com sucesso')
    }

    closeChampEditDialog = () => {
        this.setState({ champEditDialog: false })
    }

    render() {
        return (
            <div id='champContent'>
                <TopBar />
                <div style={{ height: '70px' }}></div>

                <div className="eventsBlock">
                    <Breadcrumb>
                        <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Eventos</Breadcrumb.Item>
                    </Breadcrumb>
                </div>

                <h2 style={{ width: '100%', textAlign: 'center' }}>Eventos</h2>

                <div className="eventsBlock">
                    <div style={{ width: '90%', margin: 'auto', marginTop: '30px' }}>
                        <Input
                            placeholder="Buscar evento"
                            onKeyUp={input => this.searchChamp(input.target.value)}
                            className='sharedInput'
                            style={{ width: '49%', marginRight: '2%', float: 'left' }}
                        />

                        <Button
                            onClick={() => this.openChampAddDialog()}
                            style={{ width: '49%', float: 'left' }}
                            type='primary'
                        >
                            Novo evento
                        </Button>

                        <div style={{ clear: 'both', marginBottom: '20px' }}></div>
                    </div>

                    <List
                        loading={this.state.loadingListOfChamps}
                        itemLayout="horizontal"
                        dataSource={this.state.filteredArrayOfChamps}
                        style={{ width: '90%', margin: 'auto' }}
                        renderItem={champ => (
                            <List.Item actions={[
                                <a onClick={() => this.openChampInfoDialog(champ)}>detalhes</a>,
                                <a onClick={() => this.openChampEditDialog(champ)}>editar</a>,
                                <a onClick={() => this.openChampDeleteDialog(champ)}>excluir</a>
                            ]}>
                                <List.Item.Meta
                                    title={champ.nome}
                                    description={champ.descricao}
                                />
                            </List.Item>
                        )}
                    />
                </div>

                <Modal
                    title="Informação do evento"
                    visible={this.state.champInfoDialog}
                    onCancel={this.closeChampInfoDialog}
                    footer={[
                        <Button key='close' onClick={() => this.closeChampInfoDialog()}>Fechar</Button>
                    ]}
                >
                    Nome: {this.state.champInfoObject.nome} <br /><br />
                    Descrição: {this.state.champInfoObject.descricao} <br /><br />
                    Data: {this.state.champInfoObject.dataToShow} <br /><br />
                    Observação: {this.state.champInfoObject.observacao} <br /><br />
                </Modal>

                <Modal
                    title="Cadastro de evento"
                    visible={this.state.champAddDialog}
                    onCancel={this.closeChampAddDialog}
                    footer={[
                        // <Button key='close' onClick={() => this.closeChampAddDialog()}>Cancelar</Button>
                    ]}
                >
                    <EventForm closeChampAddDialog={() => this.getReturnFromModalChampForm()} />
                </Modal>

                <Modal
                    title="Atualização de evento"
                    visible={this.state.champEditDialog}
                    onCancel={this.closeChampEditDialog}
                    footer={[
                        // <Button key='close' onClick={() => this.closeChampEditDialog()}>Cancelar</Button>
                    ]}
                >
                    <EventForm closeChampEditDialog={() => this.getReturnFromModalChampEditForm()} champToEdit={this.state.champToEdit} />
                </Modal>
            </div>
        )
    }

}

export default Events